import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Close = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 16 16"
    {...props}
    sx={{ fill: 'none', ...(props.sx || {}) }}
  >
    <line
      x1="2.70711"
      y1="3.00037"
      x2="12.7279"
      y2="13.0212"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <line
      x1="0.5"
      y1="-0.5"
      x2="14.6716"
      y2="-0.5"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 13.8001 3.00037)"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </SvgIcon>
);
